import { render } from "./TideCard.vue?vue&type=template&id=fd233bec"
import script from "./TideCard.vue?vue&type=script&lang=js"
export * from "./TideCard.vue?vue&type=script&lang=js"

import "./TideCard.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script